import React from 'react';
import { RankingEntry, Sex } from 'lib/Types';
import "./Ranking.css"
import translationsJson from 'data/translations.json';
import FemaleIcon from '@mui/icons-material/Female';
import MaleIcon from '@mui/icons-material/Male';
import { MobileDeviceContext } from 'lib/Screen';

const translations: Translations = translationsJson;

interface Props {
    names: RankingEntry[];
    title: string;
    sex?: Sex;
    nameSelected?: Function;
}

class Ranking extends React.Component<Props, {}> {
    static contextType = MobileDeviceContext;

    render() {
        let rank = 1;
        let lastCount = -1;
        let content = [];
        let maxCount = 1;
        let percent;
        let colorClass;
        if (this.props.sex === Sex.Male) {
            colorClass = "male-colors"
        } else if (this.props.sex === Sex.Female) {
            colorClass = "female-colors"
        } else {
            colorClass = "lastname-colors"
        }

        for (let i = 0; i < this.props.names.length; i++) {
            let name = this.props.names[i].name;
            let count = this.props.names[i].count;
            let avgAge = this.props.names[i].avgAge;
            if (lastCount !== -1) {
                if (lastCount !== count) {
                    rank = i + 1;
                }
            } else {
                maxCount = count;
            }
            percent = count * 100 / maxCount;
            lastCount = count;
            content.push(
                <tr key={`rank-${i}`} className={`ranking-row ${this.props.nameSelected ? 'clickable' : ''}`} onClick={() => { if (this.props.nameSelected) this.props.nameSelected(name, this.props.sex); }}>
                    <td className="ranking-row-element ranking-row-rank">{rank}.</td>
                    <td className="ranking-row-element ranking-row-name">{name}</td>
                    {!(this.props.names[0].avgAge !== undefined && this.context) && (
                        <td className="ranking-row-element ranking-row-bar">
                            <div>
                                <div style={{ width: percent + "%", height: "1.2em", border: "1px", borderStyle: "solid" }} className={colorClass}></div>
                            </div>
                        </td>
                    )}

                    <td className="ranking-row-element ranking-row-count">{count.toLocaleString('it-IT', { useGrouping: true, maximumFractionDigits: 1 })}</td>
                    {avgAge !== undefined && <td className="ranking-row-element ranking-row-count">{avgAge.toLocaleString('it-IT', { useGrouping: true, maximumFractionDigits: 1 })}</td>}
                </tr>
            );
        }

        const hasAvgAge = this.props.names.length > 0 && this.props.names[0].avgAge !== undefined;

        return (
            <div className="ranking">
                <h2 className="ranking-title">{this.props.title}{this.props.sex ? (this.props.sex === Sex.Male ? <MaleIcon className='gender-icon' /> : <FemaleIcon className='gender-icon' />) : ""}</h2>
                <table className="ranking-table">
                    <thead>
                        <tr key={'rank-head'} className={`ranking-row`} >
                            <th className="ranking-row-element ranking-row-rank">{translations.rank[window.lang]}</th>
                            <th className="ranking-row-element ranking-row-name">{translations.name[window.lang]}</th>
                            {!(hasAvgAge && this.context) && <th className="ranking-row-element ranking-row-bar"></th>}
                            <th className="ranking-row-element ranking-row-count">{translations.count[window.lang]}</th>
                            {hasAvgAge && <th className="ranking-row-element ranking-row-count">{translations.avgAge[window.lang]}</th>}
                        </tr>
                    </thead>
                    <tbody>
                        {content}
                    </tbody>
                </table>
            </div>
        );
    }
}

export default Ranking;